(function(){
  var menuStyle = document.createElement("style");
  menuStyle.textContent = "body:has(details[open].menu-opening) #ld-sale-popup, body:has(details[open].menu-opening) #ld-reservation-popup { z-index: 1 !important; }";
  document.head.appendChild(menuStyle);

  var FIRST_POPUP_DELAY = 13000;
  var SECOND_POPUP_DELAY = 45000;
  var THIRD_POPUP_DELAY = 60000;
  var FOURTH_POPUP_DELAY = 75000;
  var POPUP_DURATION = 8000;
  var RESERVATION_TIME = 274;
  
  var popupStage = parseInt(localStorage.getItem("ld_popup_stage")) || 0;
  var currentStock = parseInt(localStorage.getItem("ld_stock")) || 9;

  function updateStock() {
    var els = document.getElementsByClassName("blink-text");
    for (var i = 0; i < els.length; i++) {
      var txt = els[i].textContent;
      if (txt.indexOf("LEFT IN STOCK") > -1) {
        els[i].textContent = currentStock + " LEFT IN STOCK";
      }
    }
    
    var topBars = document.getElementsByClassName("ld-stock-display");
    for (var j = 0; j < topBars.length; j++) {
      topBars[j].textContent = currentStock;
    }

    var stockSyncs = document.getElementsByClassName("ld-stock-sync");
    for (var k = 0; k < stockSyncs.length; k++) {
      stockSyncs[k].textContent = currentStock;
    }
  }

  function showPopup(name, city, newStock, qty) {
    var qtyText = qty === 1 ? "X1 PILLOW SOLD!" : "X2 PILLOWS SOLD!";
    var popupImg = (window.LD_SCARCITY_POPUP_IMAGE || "");
    var div = document.createElement("div");
    div.id = "ld-sale-popup";
    div.innerHTML = '<style>@keyframes slideInLeft{from{transform:translateX(-100%);opacity:0}to{transform:translateX(0);opacity:1}}@keyframes slideOutLeft{from{transform:translateX(0);opacity:1}to{transform:translateX(-100%);opacity:0}}</style><div style="position:fixed;top:20px;left:20px;background:#fff;z-index:999999;padding:15px 20px;display:flex;align-items:center;gap:15px;animation:slideInLeft .5s ease;border-radius:10px;box-shadow:0 8px 30px rgba(0,0,0,0.25);max-width:320px;border:2px solid #000"><img src="'+popupImg+'" style="width:60px;height:60px;border-radius:8px;object-fit:cover"><div style="display:flex;flex-direction:column;gap:5px"><p style="margin:0;font-size:13px;color:#333;text-transform:uppercase"><strong>'+name+'</strong> FROM '+city+', US MADE A PURCHASE.</p><p style="margin:0;font-size:14px;font-weight:700;color:#000">'+qtyText+'</p><div style="display:flex;align-items:center;gap:5px;margin-top:3px"><svg width="14" height="14" viewBox="0 0 24 24"><path d="M12 2L1 21h22L12 2z" fill="#c00"/><path d="M11 9h2v5h-2zm0 6h2v2h-2z" fill="#fff"/></svg><span style="color:#c00;font-size:12px;font-weight:700;text-transform:uppercase">ONLY '+newStock+' PILLOWS LEFT IN STOCK</span><svg width="14" height="14" viewBox="0 0 24 24"><path d="M12 2L1 21h22L12 2z" fill="#c00"/><path d="M11 9h2v5h-2zm0 6h2v2h-2z" fill="#fff"/></svg></div></div></div>';
    document.body.appendChild(div);

    currentStock = newStock;
    localStorage.setItem("ld_stock", newStock);
    updateStock();

    setTimeout(function() {
      var p = document.getElementById("ld-sale-popup");
      if (p && p.firstElementChild) {
        p.firstElementChild.style.animation = "slideOutLeft .5s ease forwards";
        setTimeout(function() { p.remove(); }, 500);
      }
    }, POPUP_DURATION);
  }

  function formatTime(seconds) {
    var mins = Math.floor(seconds / 60);
    var secs = seconds % 60;
    return mins + ":" + (secs < 10 ? "0" : "") + secs;
  }

  function getHeaderHeight() {
    var header = document.querySelector('header, .header, #header, .shopify-section-header, #shopify-section-header');
    if (header) {
      return header.offsetHeight;
    }
    return 0;
  }

  function showReservationPopup() {
    var savedEndTime = localStorage.getItem("ld_reservation_end");
    var now = Date.now();
    var endTime;

    if (savedEndTime && parseInt(savedEndTime) > now) {
      endTime = parseInt(savedEndTime);
    } else {
      endTime = now + (RESERVATION_TIME * 1000);
      localStorage.setItem("ld_reservation_end", endTime);
    }

    var headerHeight = getHeaderHeight();
    var lastScrollTop = window.scrollY || document.documentElement.scrollTop;

    var div = document.createElement("div");
    div.id = "ld-reservation-popup";
    div.innerHTML = '<style>@keyframes slideDown{from{transform:translateY(-100%)}to{transform:translateY(0)}}#ld-reservation-popup .full-msg{transition:all 0.3s ease;overflow:hidden;}#ld-reservation-popup.shrunk .full-msg{max-height:0;opacity:0;margin:0 !important;padding:0 !important;}#ld-reservation-popup.expanded .full-msg{max-height:100px;opacity:1;}</style><div id="ld-res-inner" style="background:#33383c;padding:8px 15px;text-align:center;animation:slideDown .5s ease;cursor:pointer;border-bottom:2px solid #ffffff"><p class="full-msg" style="margin:0 0 6px 0;font-size:14px;font-weight:700;color:#ffffff;text-transform:uppercase">🎉 CONGRATULATIONS! YOU HAVE BEEN CHOSEN! 🎉</p><div style="display:flex;align-items:center;justify-content:center;gap:6px;flex-wrap:wrap"><svg width="14" height="14" viewBox="0 0 24 24"><path d="M12 2L1 21h22L12 2z" fill="#c00"/><path d="M11 9h2v5h-2zm0 6h2v2h-2z" fill="#fff"/></svg><span style="color:#fff;font-size:12px;font-weight:700;text-transform:uppercase">TWO LAST PILLOWS RESERVED FOR YOU</span><svg width="14" height="14" viewBox="0 0 24 24"><path d="M12 2L1 21h22L12 2z" fill="#c00"/><path d="M11 9h2v5h-2zm0 6h2v2h-2z" fill="#fff"/></svg></div><div style="display:flex;align-items:center;justify-content:center;gap:6px;margin-top:4px"><span style="color:#fff;font-size:12px;font-weight:600;text-transform:uppercase">EXPIRES IN:</span><span id="ld-timer" style="background:#c00;color:#fff;font-size:14px;font-weight:900;padding:3px 8px;border-radius:4px">'+formatTime(Math.max(0, Math.floor((endTime - now) / 1000)))+'</span></div></div>';
    
    div.style.cssText = 'position:fixed;top:'+headerHeight+'px;left:0;right:0;z-index:990;transition:top 0.3s ease;';
    
document.body.appendChild(div);
    div.classList.add("expanded");

    var stockBar = document.getElementById("ld-stock-bar");
    if (stockBar) stockBar.style.display = "none";

    var mainContent = document.getElementById("MainContent") || document.querySelector("main");
    var originalMargin = mainContent ? parseInt(window.getComputedStyle(mainContent).marginTop) || 0 : 0;

function updateBarPush() {
      setTimeout(function() {
        if (mainContent) {
          mainContent.style.transition = "margin-top 0.3s ease";
          mainContent.style.marginTop = (originalMargin + div.offsetHeight) + "px";
        }
      }, 350);
    }
updateBarPush();

    var stickyEls = document.querySelectorAll('.product__column-sticky');
    function updateStickyTop() {
      if (window.innerWidth < 750) return;
      setTimeout(function() {
      var barH = div.offsetHeight + 15;
        stickyEls.forEach(function(el) {
          el.style.top = barH + 'px';
        });
      }, 350);
    }
    updateStickyTop();

    var isExpanded = true;

    function updatePosition() {
      var currentScrollTop = window.scrollY || document.documentElement.scrollTop;
      var newHeaderHeight = getHeaderHeight();
      var headerSection = document.querySelector('.section-header');
      var headerVisible = headerSection && headerSection.classList.contains('shopify-section-header-sticky') && !headerSection.classList.contains('shopify-section-header-hidden');

      if (currentScrollTop <= newHeaderHeight) {
        div.style.top = newHeaderHeight + 'px';
      } else if (headerVisible) {
        div.style.top = newHeaderHeight + 'px';
      } else {
        div.style.top = '0px';
      }

      lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
    }

    var _scrollTicking = false;
    window.addEventListener('scroll', function() {
      if (!_scrollTicking) {
        requestAnimationFrame(function() { updatePosition(); _scrollTicking = false; });
        _scrollTicking = true;
      }
    });
    var _resizeTicking = false;
    window.addEventListener('resize', function() {
      if (!_resizeTicking) {
        requestAnimationFrame(function() {
          var newHeaderHeight = getHeaderHeight();
          if (parseInt(div.style.top) > 0) {
            div.style.top = newHeaderHeight + 'px';
          }
          _resizeTicking = false;
        });
        _resizeTicking = true;
      }
    });

div.addEventListener("click", function() {
      if (!isExpanded) {
        div.classList.remove("shrunk");
        div.classList.add("expanded");
 isExpanded = true;
        updateBarPush();
        updateStickyTop();
        setTimeout(function() {
          div.classList.remove("expanded");
          div.classList.add("shrunk");
          isExpanded = false;
          updateBarPush();
          updateStickyTop();
        }, POPUP_DURATION);
      }
    });

setTimeout(function() {
      div.classList.remove("expanded");
      div.classList.add("shrunk");
isExpanded = false;
      updateBarPush();
      updateStickyTop();
    }, POPUP_DURATION);

    var timerInterval = setInterval(function() {
      var remaining = Math.floor((endTime - Date.now()) / 1000);
      var timerEl = document.getElementById("ld-timer");
      
      if (remaining <= 0) {
        endTime = Date.now() + (RESERVATION_TIME * 1000);
        localStorage.setItem("ld_reservation_end", endTime);
        remaining = RESERVATION_TIME;
      }
      
      if (timerEl) {
        timerEl.textContent = formatTime(remaining);
      }
    }, 1000);
  }

  function checkExistingReservation() {
    var savedEndTime = localStorage.getItem("ld_reservation_end");
    if (savedEndTime && popupStage >= 4) {
      showReservationPopup();
    }
  }

  var womenNames = [
    {name: "Sarah M.", city: "Chicago"},
    {name: "Linda K.", city: "Brooklyn"},
    {name: "Patricia R.", city: "Washington"},
    {name: "Nancy D.", city: "Seattle"},
    {name: "Karen W.", city: "Dallas"},
    {name: "Betty S.", city: "Phoenix"}
  ];

  var menNames = [
    {name: "Robert T.", city: "Chicago"},
    {name: "Michael B.", city: "Brooklyn"},
    {name: "David L.", city: "Washington"},
    {name: "James P.", city: "Seattle"}
  ];

  function getRandomWoman() {
    return womenNames[Math.floor(Math.random() * womenNames.length)];
  }

  function getRandomMan() {
    return menNames[Math.floor(Math.random() * menNames.length)];
  }

  if (popupStage === 0) {
    setTimeout(function() {
      var p = getRandomWoman();
      showPopup(p.name, p.city, 7, 2);
      localStorage.setItem("ld_popup_stage", "1");
    }, FIRST_POPUP_DELAY);
    
    setTimeout(function() {
      var p = getRandomWoman();
      showPopup(p.name, p.city, 5, 2);
      localStorage.setItem("ld_popup_stage", "2");
    }, SECOND_POPUP_DELAY);
    
    setTimeout(function() {
      var p = getRandomMan();
      showPopup(p.name, p.city, 4, 1);
      localStorage.setItem("ld_popup_stage", "3");
    }, THIRD_POPUP_DELAY);
    
    setTimeout(function() {
      var p = getRandomWoman();
      showPopup(p.name, p.city, 2, 2);
      localStorage.setItem("ld_popup_stage", "4");
      setTimeout(function() {
        showReservationPopup();
      }, POPUP_DURATION + 500);
    }, FOURTH_POPUP_DELAY);
  } else if (popupStage === 1) {
    setTimeout(function() {
      var p = getRandomWoman();
      showPopup(p.name, p.city, 5, 2);
      localStorage.setItem("ld_popup_stage", "2");
    }, SECOND_POPUP_DELAY - FIRST_POPUP_DELAY);
    
    setTimeout(function() {
      var p = getRandomMan();
      showPopup(p.name, p.city, 4, 1);
      localStorage.setItem("ld_popup_stage", "3");
    }, THIRD_POPUP_DELAY - FIRST_POPUP_DELAY);
    
    setTimeout(function() {
      var p = getRandomWoman();
      showPopup(p.name, p.city, 2, 2);
      localStorage.setItem("ld_popup_stage", "4");
      setTimeout(function() {
        showReservationPopup();
      }, POPUP_DURATION + 500);
    }, FOURTH_POPUP_DELAY - FIRST_POPUP_DELAY);
  } else if (popupStage === 2) {
    setTimeout(function() {
      var p = getRandomMan();
      showPopup(p.name, p.city, 4, 1);
      localStorage.setItem("ld_popup_stage", "3");
    }, THIRD_POPUP_DELAY - SECOND_POPUP_DELAY);
    
    setTimeout(function() {
      var p = getRandomWoman();
      showPopup(p.name, p.city, 2, 2);
      localStorage.setItem("ld_popup_stage", "4");
      setTimeout(function() {
        showReservationPopup();
      }, POPUP_DURATION + 500);
    }, FOURTH_POPUP_DELAY - SECOND_POPUP_DELAY);
  } else if (popupStage === 3) {
    setTimeout(function() {
      var p = getRandomWoman();
      showPopup(p.name, p.city, 2, 2);
      localStorage.setItem("ld_popup_stage", "4");
      setTimeout(function() {
        showReservationPopup();
      }, POPUP_DURATION + 500);
    }, FOURTH_POPUP_DELAY - THIRD_POPUP_DELAY);
  } else if (popupStage >= 4) {
    checkExistingReservation();
  }

  var kachingAttempts = 0;
  function waitForKaching() {
    kachingAttempts++;
    var found = document.querySelector('.kaching-bundles .blink-text');
    if (found) {
      updateStock();
    } else if (kachingAttempts < 20) {
      setTimeout(waitForKaching, 500);
    }
  }

  function init() {
    updateStock();
    setTimeout(updateStock, 500);
    setTimeout(updateStock, 1500);
    waitForKaching();
  }

  if (document.readyState === "complete") {
    init();
  } else {
    window.addEventListener("load", init);
  }
})();

